var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Authentication } from "./authentication";
import axios from "axios";
import { checkBaseUrlSlash } from "@pga/utils/checkUrlSlash/checkUrlSlash";
//  جهت انقضای توکن
function tokenIsExpired(expiryDate) {
    const expiryDateAdjusted = new Date(expiryDate);
    const now = new Date();
    const expired = expiryDateAdjusted < now;
    return expired;
}
export const getAccessToken = (apiUrl, loginUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const localStorageAuthentication = Authentication.get();
    function goToLogin() {
        Authentication.clear();
        window.location.href = loginUrl;
    }
    if (localStorageAuthentication === null || localStorageAuthentication === void 0 ? void 0 : localStorageAuthentication.accessToken) {
        if (localStorageAuthentication.accessTokenExpiration) {
            if (tokenIsExpired(localStorageAuthentication.accessTokenExpiration)) {
                if (tokenIsExpired(localStorageAuthentication.refreshTokenExpiration)) {
                    goToLogin();
                }
                else {
                    try {
                        const resData = yield axios.get(`${checkBaseUrlSlash()}${apiUrl}`, {
                            headers: {
                                Authorization: "Bearer " + localStorageAuthentication.refreshToken,
                            },
                        });
                        if (resData.data.success) {
                            Authentication.set(resData.data.data);
                            return resData.data.data.accessToken;
                        }
                        else {
                            goToLogin();
                        }
                    }
                    catch (error) {
                        goToLogin();
                    }
                }
            }
        }
    }
    else {
        goToLogin();
    }
    return localStorageAuthentication === null || localStorageAuthentication === void 0 ? void 0 : localStorageAuthentication.accessToken;
});
